import "./Dash.css"
import React, {useState, useEffect} from "react";
import Profile from "./Profile";
import Residents from './Residents';
import Residences from './Residences';
import Accounts from './Accounts';
import {useUserData} from "../Contexts/UserDataContext"
import PayDues from "./PayDues";
import SendAlerts from './SendAlerts'
import EditCalendar from './EditCalendar'
import KeyFobs from "./KeyFobs"
import { useNavigate } from 'react-router-dom';
import Sidebar from "./Sidebar";
import Banner from './Banner';

const DashHandler = () => {
  const navigate = useNavigate()
  const {userData, loading, setUID, setUserData} = useUserData()
  const [chosenPage, setChosenPage] = useState("profile")
  const [chosenCompany,setChosenCompany] = useState("")
  const [sidebarStatus,setSidebarStatus] = useState(true)
  
  useEffect(() => {
    if (!userData && !loading) {
      navigate("/login");
    }

  }, [userData, loading, navigate]);





  const DashboardSplitter = () => {
    switch(chosenPage){
      case "profile":
        return <Profile sidebarStatus={sidebarStatus}/>
      case "payDues":
        return <PayDues sidebarStatus={sidebarStatus}/>  
      case "residences":
        return <Residences sidebarStatus={sidebarStatus}/>
      case "residents":
        return <Residents sidebarStatus={sidebarStatus}/>
      case "accounts":
        return <Accounts sidebarStatus={sidebarStatus}/>
      case "keyFobs":
        return <KeyFobs sidebarStatus={sidebarStatus}/>
      case "editCalendar":
        return <EditCalendar sidebarStatus={sidebarStatus}/>
      case "sendAlerts":
        return <SendAlerts sidebarStatus={sidebarStatus}/>
      case "editBanner":
        return <Banner sidebarStatus={sidebarStatus} />
      default:
        return <Profile sidebarStatus={sidebarStatus}/>
    }
  }

  const pageTitles = {
    profile: ['Resident dashboard', 'Your Indian Park account at a glance'],
    payDues: ['Association dues', 'Payments and account balance'],
    residences: ['Residences', 'Manage properties in Indian Park'],
    residents: ['Residents', 'Review members and access requests'],
    editCalendar: ['Community calendar', 'Create and manage public events'],
    editBanner: ['Homepage notice', 'Update the public announcement bar'],
    sendAlerts: ['Resident alerts', 'Send an email and text broadcast'],
  }

  const [pageTitle, pageDescription] = pageTitles[chosenPage] || pageTitles.profile


  
  return(
    <div className="dash-app">
      <Sidebar 
        setUserData={setUserData} 
        setUID={setUID} 
        chosenPage={chosenPage} 
        setChosenPage={setChosenPage} 
        sidebarStatus={sidebarStatus} 
        setSidebarStatus={setSidebarStatus} 
        setChosenCompany={setChosenCompany} 
        chosenCompany={chosenCompany}
      />
      <main className={`dash-content ${sidebarStatus ? 'sidebar-open' : 'sidebar-closed'}`}>
        <header className="dash-topbar">
          <div>
            <span className="dash-kicker">Indian Park Association</span>
            <h1>{pageTitle}</h1>
            <p>{pageDescription}</p>
          </div>
          <div className="dash-user-chip">
            <span>{(userData?.name || 'Resident').charAt(0).toUpperCase()}</span>
            <div><strong>{userData?.name || 'Resident'}</strong><small>{userData?.isAdmin ? 'Administrator' : 'Resident'}</small></div>
          </div>
        </header>
        <div className="dash-page"><DashboardSplitter /></div>
      </main>
    </div>
  )
}

export default DashHandler;
